'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthBitGrid = require('@narvar/nth-bit-grid');
var React = require('react');
var uuid = require('uuid');
var layoutTree = require('./layoutTree.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var uuid__namespace = /*#__PURE__*/_interopNamespace(uuid);

// NOTE: Used for exhaustive matching.
const emptyRender = (_nodeType, key) => /*#__PURE__*/React__default["default"].createElement(React.Fragment, {
  key: key
});
const renderLayout = options => {
  if (!options) return /*#__PURE__*/React__default["default"].createElement(React.Fragment, null);
  const {
    node,
    view,
    row,
    col,
    feature
  } = options;
  const key = node?.id ?? uuid__namespace.v4();
  if (node.type === layoutTree.TreeNodeTypes.FEATURE) {
    return /*#__PURE__*/React__default["default"].createElement(nthBitGrid.Content, {
      key: key
    }, feature({
      node: Object.freeze({
        ...node,
        children: null
      })
    }));
  }
  const childrenMapCallback = child => renderLayout({
    node: child,
    view,
    row,
    col,
    feature
  });
  if (node.type === layoutTree.TreeNodeTypes.VIEW) {
    return /*#__PURE__*/React__default["default"].createElement(React.Fragment, {
      key: key
    }, view({
      node: Object.freeze({
        ...node,
        children: null
      }),
      children: node.children.map(childrenMapCallback)
    }));
  }
  if (node.type === layoutTree.TreeNodeTypes.ROW) {
    return /*#__PURE__*/React__default["default"].createElement(React.Fragment, {
      key: key
    }, row({
      node: Object.freeze({
        ...node,
        children: null
      }),
      children: node.children.map(childrenMapCallback)
    }));
  }
  if (node.type === layoutTree.TreeNodeTypes.COL) {
    return /*#__PURE__*/React__default["default"].createElement(React.Fragment, {
      key: key
    }, col({
      node: Object.freeze({
        ...node,
        children: null
      }),
      children: node.children.map(childrenMapCallback)
    }));
  }

  // NOTE: Exhaustive matching.
  const {
    type
  } = node;
  return emptyRender(type, key);
};

exports["default"] = renderLayout;
